/*******************************************************************************
 * Dependency Imports
 ******************************************************************************/
// auth::api
import * as Api from './api'
// lodash - https://lodash.com/
import _ from 'lodash'

/*******************************************************************************
 * Services
 ******************************************************************************/

/*******************************************************************************
 * Configuration
 ******************************************************************************/

/*******************************************************************************
 * Transformer prototypes
 ******************************************************************************/

/*******************************************************************************
 * Private methods
 ******************************************************************************/

/**
 * general success
 *
 * @param {obj} data
 * @return {obj} le data
 */
const _onSuccess = data => {

    if( _.get( data, 'data.data' ) ) {
        return _.get( data, 'data.data' )
    }

    return data

}

/**
 * general fail
 *
 * @param {obj} error from a server
 * @return {obj} the error
 */
const _onFailed = error => new Promise(( resolve, reject ) => {

    let error_obj = error.hasOwnProperty( 'response' ) ? error.response : error

    reject( _.get( error_obj, 'data', null ) || error_obj )

})

/*******************************************************************************
 * Public methods
 ******************************************************************************/

/**
 * list all support tickets
 *
 * @return {promise}
 */
export const list = async params =>
    Api.list(params)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * show a single support ticket
 * @param support_ticket_id
 * @returns {Promise<obj>}
 */
export const show = async support_ticket_id =>
    Api.show(support_ticket_id)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * create a support ticket
 * @param data
 * @returns {Promise<obj>}
 */
export const create = async data =>
    Api.create(data)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * update a single support ticket
 * @param support_ticket_id
 * @param data
 * @returns {Promise<obj>}
 */
export const update = async (support_ticket_id, data) =>
    Api.update(support_ticket_id, data)
        .then( _onSuccess )
        .catch( _onFailed )

export const addMedia = async (support_ticket_id, payload) =>
    Api.addMedia(support_ticket_id, payload)
        .then( _onSuccess )
        .catch( _onFailed )

export const getComments = async support_ticket_id =>
    Api.getComments(support_ticket_id)
        .then( _onSuccess )
        .catch( _onFailed )

export const createComment = async (support_ticket_id, comment_data) =>
    Api.createComment(support_ticket_id, comment_data)
        .then( _onSuccess )
        .catch( _onFailed )

export const getCommentParticipants = async support_ticket_id =>
    Api.getCommentParticipants(support_ticket_id)
        .then( _onSuccess )
        .catch( _onFailed )
